// extracted by mini-css-extract-plugin
module.exports = {"clip":"styles_clip__1NhWR","clip_absolute":"styles_clip_absolute__10fXY","clipPreview":"styles_clipPreview__Uoz5f"};